// Adaptive Module 6: Verbal Reasoning - Fill in the Blanks
// Based on Module 6-2 dialogue completion task

import React from 'react';
import AssessmentWrapper from '../../AssessmentWrapper';
import Module6_2 from '../module6-2';

// Define Module 6 instances (simplified structure for now)
const MODULE_6_INSTANCES = {
  1: { id: 'd1', difficulty: 1, description: 'Difficulty 1 instance' },
  2: { id: 'd2', difficulty: 2, description: 'Difficulty 2 instance' },
  3: { id: 'd3', difficulty: 3, description: 'Difficulty 3 instance' },
  4: { id: 'd4', difficulty: 4, description: 'Difficulty 4 instance' },
  5: { id: 'd5', difficulty: 5, description: 'Difficulty 5 instance' },
  6: { id: 'd6', difficulty: 6, description: 'Difficulty 6 instance' },
  7: { id: 'd7', difficulty: 7, description: 'Difficulty 7 instance' },
  8: { id: 'd8', difficulty: 8, description: 'Difficulty 8 instance' },
  9: { id: 'd9', difficulty: 9, description: 'Difficulty 9 instance' },
  10: { id: 'd10', difficulty: 10, description: 'Difficulty 10 instance' }
};

const VerbalReasoningContent = ({ instance, onSubmit, instanceNumber, moduleId }) => {
  // The Module 6-2 component already handles the verbal reasoning task
  // We'll reuse it as the content for our adaptive wrapper
  
  const handleComplete = (data) => {
    // Module 6-2 should call onSubmit when the task is completed
    // The adaptive wrapper will handle difficulty adjustment
    if (onSubmit) {
      onSubmit({
        ...data,
        isCorrect: true, // Module 6-2 will determine correctness
        responseTime: Date.now() - (instance.startTime || Date.now())
      });
    }
  };

  return (
    <Module6_2 
      nextPage={handleComplete}
      instanceData={instance}
      instanceNumber={instanceNumber}
    />
  );
};

const AdaptiveModule6 = ({ onModuleComplete, moduleType, cardData }) => {
  console.log('🎯 AdaptiveModule6 rendering with:', { onModuleComplete: !!onModuleComplete, moduleType, cardData: cardData?.length });
  
  // Use AssessmentWrapper for proper adaptive functionality
  const renderContent = ({ instance, onSubmit, instanceNumber, moduleId }) => {
    const handleComplete = (data) => {
      console.log(`🎯 Module 6 adaptive handleComplete received:`, data);
      if (onSubmit) {
        // For Module 6, use percentage-based progression (≥80% correct = advance)
        const percentage = data.percentage || 0;
        const progressionCorrect = percentage >= 0.8;
        
        onSubmit(progressionCorrect, {
          ...data,
          responseTime: Date.now() - (instance.startTime || Date.now()),
          customPoints: data.points // Pass through the custom points calculation
        });
      }
    };

    return (
      <Module6_2 
        difficulty={instance.difficulty}
        instance={instance}
        nextPage={handleComplete}
        instanceNumber={instanceNumber}
        cardData={cardData}
      />
    );
  };

  return (
    <AssessmentWrapper
      moduleType="6"
      onModuleComplete={onModuleComplete}
      isAdaptive={true}
      renderAdaptiveContent={renderContent}
    />
  );
};

export default AdaptiveModule6;